// extracted by mini-css-extract-plugin
export var container = "index-module--container--22OrK";
export var content = "index-module--content--1SGuR";
export var leftBox = "index-module--leftBox--31HMm";
export var rightBox = "index-module--rightBox--1WDgw";
export var reversedContent = "index-module--reversedContent--2xIUh";